module.exports = __webpack_public_path__ + "static/media/gal06032.4c59f9a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ressources/gal06/gal06032.jpg
// module id = 507
// module chunks = 0